module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAA3XAAAN1wFCKJt4AAAAB3RJTUUH4QsHDAse6yp24wAAANJJREFUSMft1jFKw3AUx/FPY8gugmtvIKgHsFMuktxA0dPkAnqFYJ2bSFvwBBlbwblZdGgCWdySTP8vPHiPB+8Lb/pxJsYLPnHC70h1Qt3djg1kHyNK/qs14hhPeFgul4qicH9zZUzq/bcsyzRNs8LjonvjXVmWo8t6qt1RmqZQL7o/Jz+HrSm5vL6FNkJiPpLIzARhEAZhEAZhEAbhWdjO6GsjfPXpaiqq3bFv9xFeIc/z4WI0NtuDPM/78a0PwusZgvA7Lobp+xnVBFF/092O4Q9P5Yh4xIVlGgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/territorio_municipios.png
// module id = lLLT
// module chunks = 0